/**
 * Interaction blocks
 *
 * This component requires jQuery and Slick to function.
 * You can require it on the page using <div data-component="interaction-blocks"></div>
 */
import 'slick-carousel';
$(function () {
  $('[data-component="interaction-blocks"]').each(function () {
    let $holder = $(this);
    let $item = $('.js-interaction-link', $holder);
    $item.parent().eq(0).addClass('is-hover');
    $item.parent().hover(function () {
      $item.parent().removeClass('is-hover');
      $(this).addClass('is-hover');
    });
    $item.on('click', function () {
      if ($(this).parent().hasClass('is-active')) {
        $(this).parent().removeClass('is-active');
        $('.interaction-blocks__list', $holder).removeClass('is-open');
      } else {
        $('.js-interaction-link', $holder).parent().removeClass('is-active');
        $(this).parent().addClass('is-active');
        $('.interaction-blocks__list', $holder).addClass('is-open');
      }
    }); // slider

    var $slick_slider = $('.js-interaction-slider', $holder);
    var $settings_slider = {
      rows: 0,
      dots: true,
      infinite: false,
      swipeToSlide: true,
      arrows: false,
      slidesToShow: 1,
      variableWidth: true,
      mobileFirst: true,
      slidesToScroll: 1,
      responsive: [{
        breakpoint: 767,
        settings: 'unslick'
      }]
    };
    slick_on_mobile($slick_slider, $settings_slider);

    function slick_on_mobile(slider, settings) {
      $(window).on('load resize', function () {
        if ($(window).width() > 767) {
          if (slider.hasClass('slick-initialized')) {
            slider.slick('unslick');
          }

          return;
        }

        if (!slider.hasClass('slick-initialized')) {
          return slider.slick(settings);
        }
      });
    }
  });
});